import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  Switch,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import {
  IconEdit,
  IconPlus,
  IconSearch,
  IconTrash,
  IconNews,
  IconBookmarks,
  IconBookmark,
  IconArticle,
  IconFileText,
  IconFolder,
  IconFolderOpen,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useMemo, useState } from "react";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { _localization } from "../../../config/location";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import CreateView from "./CreateView";
import DeleteView from "./DeleteView";
import EditView from "./EditView";
import { ArticleCategoryTree } from "../../../model/ArticleCategoryTree";
import { IconTimeDuration15 } from "@tabler/icons-react";
import { useLocation } from "react-router-dom";
interface SearchCriteria {
  keySearch?: string;
  status?: string;
  location?: string;
}

const ArticleCategory = () => {
  const location = useLocation();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [searchKeyword, setSearchKeyword] = useState(
    _searchJson && checkedPinSearch ? _searchJson?.searchKeyword : ""
  );
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<ArticleCategoryTree[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;

  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {},
  });
  const getTypeArticle = (type: any) => {
    switch (type) {
      case 1:
        return "Chỉ hiển thị danh mục con";
      case 2:
        return "Chỉ hiển thị bài";
      case 3:
        return "Hiển thị bài + Danh mục con";
      default:
        return "Chỉ hiển thị danh mục con";
    }
  };
  const styleTableMantine = {
    fontWeight: "500",
  };
  const updateLocalData = (
    id: number,
    field: "active" | "priority",
    value: string
  ) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const filteredData = useMemo(() => {
    if (!searchKeyword.trim()) return data;

    return data.filter((item) =>
      item.name.toLowerCase().includes(searchKeyword.toLowerCase())
    );
  }, [data, searchKeyword]);

  const columns = React.useMemo<MRT_ColumnDef<ArticleCategoryTree>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        enableColumnFilter: false,
        enableSorting: false,
        size: 80,
        Cell: ({ row }) => {
          const getFormattedIndex = (row: any): string => {
            let index = row.index + 1;
            let parent = row.getParentRow?.();
            let formatted = `${index}`;
            while (parent) {
              formatted = `${parent.index + 1}.${formatted}`;
              parent = parent.getParentRow?.();
            }
            return formatted;
          };

          const getColorByDepth = (depth: number) => {
            switch (depth) {
              case 0:
                return "#228be6"; // xanh lam - danh mục cha
              case 1:
                return "#40c057"; // xanh lá - danh mục con
              case 2:
                return "#fd7e14"; // cam - bài viết cấp 2
              default:
                return "#e03131"; // đỏ - bài viết cấp sâu
            }
          };

          const getIconByDepth = (depth: number) => {
            const size = 16;
            switch (depth) {
              case 0:
                return <IconBookmarks size={size} color="#228be6" />; // icon danh mục cha - màu xanh lam
              case 1:
                return <IconBookmark size={size} color="#40c057" />; // icon danh mục con cấp 1 - màu xanh lá
              case 2:
                return <IconNews size={size} color="#fd7e14" />; // icon bài viết cấp 2 - màu cam
              default:
                return <IconArticle size={size} color="#e03131" />; // icon bài viết cấp sâu - màu đỏ
            }
          };

          return (
            <Flex align="center" gap="xs">
              {getIconByDepth(row.depth)}
              <span
                style={{
                  color: getColorByDepth(row.depth),
                  fontWeight: 500,
                  fontSize: 14,
                }}
              >
                {getFormattedIndex(row)}
              </span>
            </Flex>
          );
        },
      },
      {
        accessorKey: "name",
        header: "Danh mục bài viết",
        size: 250,
      },
      {
        accessorKey: "articleCount",
        accessorFn: (row) => row.articleCount ?? 0,
        header: "Số bài viết",
        size: 150,
      },
      {
        accessorKey: "displayOption",
        header: "Hiển thị",
        size: 200,
        Cell: ({ row }) => {
          const getDisplayOptionLabel = (displayOption: string): string => {
            switch (displayOption) {
              case "child_only":
                return "Chỉ hiển thị danh mục con";
              case "article":
                return "Chỉ hiển thị bài";
              case "child_article":
                return "Hiển thị bài + Danh mục con";
              default:
                return "Chỉ hiển thị danh mục con";
            }
          };
          return (
            <Text>{getDisplayOptionLabel(row.original.displayOption)}</Text>
          );
        },
      },
      {
        accessorKey: "link",
        header: "Đường dẫn",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => (
          <Group>
            <a
              href={`${hacomUrl}/tin-tuc/${row.original.requestPath}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1c7ed6", textDecoration: "underline" }}
            >
              Xem trang bài viết
            </a>
          </Group>
        ),
      },
      {
        accessorKey: "orderNumber",
        header: "Thứ tự",
        size: 135,
      },
      {
        accessorKey: "note",
        header: "Ghi chú",
        size: 300,
      },

      {
        accessorKey: "status",
        header: "Trạng thái",
        size: 200,
        Cell: ({ row }) => (
          <>
            <Switch
              checked={row.original.status === "Y"}
              color="blue"
              size="xs"
              mr={3}
              onChange={async () => {
                await handleEditStatus(row.original.id);
              }}
            />
            <Text>
              {" "}
              {row.original.status === "Y"
                ? " Đang hoạt động"
                : "Không hoạt động"}
            </Text>
          </>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác ",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 135,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                color="yellow"
                onClick={() => editItem(row.original.id)}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                color="red"
                onClick={async () => {
                  await deleteItem([row.original.id]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    []
  );

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

    try {
      const search = form.getValues();

      const queryParams = new URLSearchParams();

      if (search && search.keySearch) {
        queryParams.append("KeySearch", search.keySearch);
      }
      if (search && search.status) {
        queryParams.append("SearchType", search.status);
      }
      if (pagination) {
        queryParams.append(
          "Skip",
          String(pagination.pageIndex * pagination.pageSize)
        );
        queryParams.append("Take", String(pagination.pageSize));
      }

      const url = `${
        API_ROUTE.GET_LIST_ARTICLE_CATEGORY
      }?${queryParams.toString()}`;
      const response = await repository.get(url);
      if (response) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  // Modal thêm mới danh mục bài viết
  const openModal = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm mới danh mục bài viết</Title>
          </div>
        </>
      ),
      children: <CreateView datas={data} onSearch={() => fetchData()} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  const handleEditStatus = async (id: number) => {
    if (id < 1)
      NotificationExtension.Fails("Mã nội dung cố định không tồn tại !");
    else {
      setIsLoading(true);
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      try {
        let urlSearch = API_ROUTE.MODIFY_STATUS_ARTICLE_CATEGORY + id;
        let callapi = await repository.post<MessageResponse<boolean>>(
          urlSearch
        );
        if (isNullOrUndefined(callapi)) {
          NotificationExtension.Fails(
            "Thao tác không thành công, xin vui lòng thử lại !"
          );
        } else {
          if (callapi?.success) {
            NotificationExtension.Success("Thao tác thành công !");
            await fetchData();
          } else NotificationExtension.Fails("Thao tác thất bại !");
        }
        return callapi?.data;
      } catch (error: any) {
        throw new Error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa danh mục</Title>
        </>
      ),
      children: <DeleteView onSearch={() => fetchData()} idItem={idItem} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }
  // Modal chỉnh sửa danh mục bài viết
  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa danh mục bài viết!</Title>
        </>
      ),

      children: <EditView id={id} onSearch={() => fetchData()} datas={data} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  }

  const table = useMantineReactTable<ArticleCategoryTree>({
    columns,
    data: filteredData,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,

    // Thêm hỗ trợ tree structure
    enableExpanding: true,
    enableExpandAll: true,
    paginateExpandedRows: true,
    enableSubRowSelection: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["status", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    mantineTableContainerProps: {
      style: {
        maxHeight: height,
        minHeight: height,
        overflowX: "auto",
      },
    },
    enableStickyHeader: true,
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,

    // Thêm styling cho tree structure
    mantineTableBodyCellProps: ({ row, cell }) => {
      const indentPx = row.depth * 20;
      const targetColumns = ["STT", "name"]; // Các cột cần lùi

      return {
        style: {
          fontWeight: 550,
          fontSize: "12px",
          padding: "6px 8px",
          paddingLeft: targetColumns.includes(cell.column.id)
            ? `${indentPx + 4}px`
            : "4px",
        },
      };
    },

    mantineTableBodyRowProps: ({ row }) => ({
      style: {
        backgroundColor: row.depth === 0 ? "#f9f9f9" : "#fff", // Màu nền cho hàng cha và con
      },
    }),

    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    getRowId: (row) => row.id?.toString(),
    getSubRows: (row: ArticleCategoryTree) => {
      if (
        !row.tblArticleCategoryModels ||
        !Array.isArray(row.tblArticleCategoryModels)
      ) {
        return []; // Trả về mảng rỗng nếu không có dữ liệu con
      }
      return row.tblArticleCategoryModels;
    },
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (170 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  useEffect(() => {
    fetchData();
  }, [pagination]);
  return (
    <Box>
      <Group gap={0} justify="space-between" mb={10}>
        <BreadCrumb></BreadCrumb>
      </Group>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        {/* Thông báo thời gian đồng bộ dữ liệu lên web */}
        <Box
          style={{
            background: "#fffbe6",
            border: "1.5px solid #ffe58f",
            borderRadius: 8,
            padding: "5px",
            marginBottom: 2,
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontWeight: 600,
            color: "#ad6800",
            fontSize: 14,
          }}
        >
          <IconTimeDuration15
            size={22}
            color="#faad14"
            style={{ marginRight: 6 }}
          />
          <span>
            <b>Lưu ý:</b> Sau khi cập nhật,có thể dữ liệu sẽ được đồng bộ lên
            website trong khoảng <b>15-30 phút</b>. Vui lòng kiểm tra lại sau
            thời gian này để thấy thay đổi.
          </span>
        </Box>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid mt={10}>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                placeholder="Nhập tìm kiếm"
                key={form.key("keySearch")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                value={searchKeyword}
                onChange={(e) => {
                  setSearchKeyword(e.currentTarget.value);
                  sessionStorage.setItem(
                    String(location.pathname),
                    JSON.stringify({ searchKeyword: e.currentTarget.value })
                  );
                }}
              />
            </Grid.Col>
          </Grid>
          <Group>
            <Button
              mt={10}
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                openModal();
              }}
            >
              Thêm mới
            </Button>
            <Button
              mt={10}
              mr={10}
              leftSection={<IconTrash size={14} />}
              color="red"
              variant="outline"
              onClick={async () => {
                const selectedIds = Object.keys(rowSelection).map(
                  (key) => data[Number(key)].id
                );
                if (selectedIds && selectedIds.length < 1) {
                  NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                  return null;
                }
                await deleteItem(selectedIds);
              }}
            >
              Xóa (Đã chọn)
            </Button>
          </Group>
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default ArticleCategory;
